import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home'
import Report from '@/views/Report'
import Reports from '@/views/Reports'
import Unauthorized from '@/views/Unauthorized'
import SavedReports from '@/views/SavedReports'
import FavoriteReports from '@/views/FavoriteReports'
import Public from '@/views/Public'
import Dashboards from '@/views/Dashboards'
import Dashboard from '@/views/Dashboard'
import FYUserMenu from '@/views/FYUserMenu'
import FYUserFinalize from '@/views/FYUserFinalize'
import QTRMenu from '@/views/QTRMenu'
import AdditionalDashboards from '@/views/AdditionalDashboards'

Vue.use(Router)

import ARMLib from 'arm-vue-lib'

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/',
      name: 'home',
      component: Home
    },

    // Generic forms
    {
      path: '/:formType/search',
      name: 'FormSearch',
      component: ARMLib._components.GraphQLFormSearch,
      props(route) {
        const props = { ...route.params }
        return props
      }
    },
    {
      path: '/:formType/edit/:recordId',
      name: 'FormEditRecord',
      component: ARMLib._components.GraphQLFormEdit,
      props(route) {
        const props = { ...route.params }
        if (props.recordId && !isNaN(props.recordId)) {
          props.recordId = +props.recordId
        }
        return props
      }
    },
    {
      path: '/:formType/edit/:recordId/:activeTab',
      name: 'FormEditRecordTab',
      component: ARMLib._components.GraphQLFormEdit,
      props(route) {
        const props = { ...route.params }
        if (props.recordId && !isNaN(props.recordId)) {
          props.recordId = +props.recordId
        }
        return props
      }
    },
    {
      path: '/:formType/edit',
      name: 'FormEdit',
      component: ARMLib._components.GraphQLFormEdit,
      props(route) {
        const props = { ...route.params }
        return props
      }
    },

    // Metrics routes
    {
      path: '/favorites',
      name: 'Favorites',
      component: FavoriteReports
    },
    {
      path: '/saved',
      name: 'Saved',
      component: SavedReports
    },
    {
      path: '/shared',
      name: 'Shared',
      component: SavedReports,
      props: { shared: true }
    },
    {
      path: '/reports/',
      name: 'Reports',
      component: Reports
    },
    {
      path: '/reports/:category',
      name: 'ReportCategory',
      component: Reports,
      props(route) {
        const props = { ...route.params }
        return props
      }
    },
    {
      path: '/report/:name',
      name: 'Report',
      component: Report,
      props(route) {
        const props = { ...route.params }
        return props
      }
    },

    {
      path: '/dashboards/',
      name: 'Dashboards',
      component: Dashboards
    },
    {
      path: '/dashboard/:name',
      name: 'Dashboard',
      component: Dashboard,
      props(route) {
        const props = { ...route.params }
        return props
      }
    },

    {
      path: '/fy-user',
      name: 'FYUserMenu',
      component: FYUserMenu
    },
    {
      path: '/fy-user/finalize',
      name: 'FYUserFinalize',
      component: FYUserFinalize
    },

    {
      path: '/qtr',
      name: 'QTRMenu',
      component: QTRMenu
    },

    {
      path: '/additional-dashboards',
      name: 'AdditionalDashboards',
      component: AdditionalDashboards
    },

    {
      path: '/public/:saveId',
      name: 'Public',
      component: Public,
      props(route) {
        return { saveId: +route.params.saveId }
      },
      meta: {
        standalone: true,
        override: 'inDash',
        overrideInfrastructure: true
      }
    },
    {
      path: '/public-dashboard/:name',
      name: 'PublicDashboard',
      component: Dashboard,
      props(route) {
        const props = { ...route.params }
        return props
      },
      meta: {
        standalone: true,
        dashboardOnly: true
      }
    },

    // Unauthorized page
    {
      path: '/unauthorized',
      name: 'Unauthorized',
      component: Unauthorized,
      meta: { single: true }
    },

    // Default route if none specified.
    { path: '*', redirect: '/' }
  ]
})
